/**
 * CustomerIdentification
 * Provides identity validation based off information submitted for specific customer.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnswerRequestMock } from './answerRequestMock';
import { QuestionAnswerInterface } from './questionAnswer';


export interface AnswerRequestInterface { 
    idNumber: string;
    answers?: Array<QuestionAnswerInterface>;
    mock?: AnswerRequestMock;
}

